import {
  isFixedLengthMultiDayLiveClass,
  isLiveClassroomV2Format,
} from "@outschool/business-rules";

import { useLearnerClassroomContext } from "../../providers/LearnerClassroomProvider";

type LearnerClassroomLayoutSection = {
  classroomLayoutVersion?: number | null;
  is_self_paced?: boolean | null;
};

type LearnerClassroomLayoutSyllabus = {
  layoutVersion?: number | null;
};

type LearnerClassroomLayoutActivity = Parameters<
  typeof isFixedLengthMultiDayLiveClass
>[0] & {
  isSelfPaced?: boolean | null;
};

/**
 * Supported self-paced, fixed-length live, and ongoing group classrooms follow
 * the persisted V2 layout. Other live formats keep their existing learner
 * classroom.
 */
export function isLearnerClassroomV2Layout(
  section: LearnerClassroomLayoutSection | null | undefined,
  syllabus: LearnerClassroomLayoutSyllabus | null | undefined,
  activity?: LearnerClassroomLayoutActivity | null,
): boolean {
  const isV2 =
    (section?.classroomLayoutVersion ?? syllabus?.layoutVersion ?? 1) === 2;
  if (!activity || !isV2) {
    return false;
  }
  return activity.isSelfPaced === true
    ? section?.is_self_paced === true
    : isLiveClassroomV2Format(activity);
}

export function useIsLiveClassroomV2(): boolean {
  const { activity, section, syllabus } = useLearnerClassroomContext();

  return (
    activity != null &&
    !activity.isSelfPaced &&
    isLearnerClassroomV2Layout(section, syllabus, activity)
  );
}
